<template>
    <van-empty image="network" description="服务器内部错误，请联系管理员"/>
</template>
<script>
    import {Empty} from 'vant';

    export default {
        components: {[Empty.name]: Empty},
        data() {
            return {}
        }
    }
</script>
<style scoped></style>
